import { getParams } from '../../utils';
const getInit = {
  method: 'GET',
  credentials: 'include',
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
};
const putInit = {
  method: 'PUT',
  credentials: 'include',
  headers: { 'Content-Type': 'application/json' },
};
export const ctApplicationList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch('/ai-web-ct/diagnosis/applicationList', init).then(
    res => res.json(),
    error => console.error(error)
  );
};

export const nbReviewList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch('/ai-web-ct/diagnosis/nbReviewList', init).then(
    res => res.json(),
    error => console.error(error)
  );
};

export const reviewNB = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch('/ai-web-ct/diagnosis/reviewNb', init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//新增报告申请
export const ctSaveApplication = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web-ct/diagnosis/saveApplication`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//修改申请单
export const ctUpdateApplication = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  let url = `/ai-web-ct/diagnosis/updateApplication`;
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//查看申请单详情
export const ctApplicationInfo = id => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/diagnosis/applicationInfo?applicationId=${id}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//申请单作废/恢复
export const ctUpdateValid = (id, state) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/diagnosis/updateValid?diagId=${id}&validFlag=${state}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//填写报告
export const ctWriteReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/writeReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//暂存报告/提交报告
export const ctSaveReport = post => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(post),
  };
  return fetch(`/ai-web-ct/diagnosis/saveReport`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//修改医生审核状态
export const setDoctorReviewStatus = (id, status) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/fromDr/setDoctorReviewStatus?dicomDrId=${id}&status=${status}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//修改医生审核状态（合并后）
export const setDoctorReviewStatus4Study = (id, status) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/fromDr/setDoctorReviewStatus4Study?studyDrId=${id}&status=${status}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//立即申请
export const ctApply = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/apply?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//获取可以合并的片子列表
export const applyRelatedDrList = id => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/diagnosis/applyRelatedDrList?diagId=${id}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

// 审核报告
export const ctVerifyReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/verifyReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

// 提交审核
export const ctSaveVerify = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web-ct/diagnosis/saveVerify`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//暂存审核
export const ctTempSaveVerify = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web-ct/diagnosis/tempSaveVerify`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//操作记录
export const ctOperationRecord = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/operationRecord?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//预览报告
export const ctReportInfo = id => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/diagnosis/reportInfo?applicationId=${id}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//拒绝原因列表
export const ctRefuseReportReason = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/dict/refuseReportReason`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//查看拒绝原因
export const ctRefuseReason = id => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/diagnosis/refuseReportReason?applicationId=${id}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//拒绝报告
export const ctRefuseReport = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web-ct/diagnosis/refuseReport`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//知识库树查询
export const ctKnowledgeTree = (flag, id, text) => {
  const init = { method: 'GET' };
  let url = `/ai-web-ct/knowledge/tree`;
  if (flag !== undefined) {
    url += `?privateFlag=${flag}`;
    if (id) url += `&rootId=${id}`;
    if (text) url += `&keyword=${text}`;
  } else {
    if (id) url += `?rootId=${id}`;
    if (text) url += `&keyword=${text}`;
  }

  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//知识库根据ID查询详情
export const ctKnowledgeInfoById = id => {
  return fetch(`/ai-web-ct/knowledge/selectById?id=${id}`, getInit).then(
    res => res.json(),
    error => console.error(error)
  );
};

//知识库查询-列表
export const ctKnowledgeList = (flag, text, page, size) => {
  const init = { method: 'GET' };
  let url = `/ai-web-ct/knowledge/pageSelect?privateFlag=${flag}`;
  if (text) url += `&keyword=${text}`;
  if (page && size) url += `&pageSize=${size}&pageNum=${page}`;
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//知识库根据ID查询详情
export const knowledgeDelectById = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/knowledge/selectById?id=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//放弃报告
export const ctQuitReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/quitReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//放弃审核
export const ctQuitVerify = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/quitVerify?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//历史信息
export const ctReportHis = (reportId, diagId) => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/diagnosis/reportHis?reportId=${reportId}&diagId=${diagId}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//新增知识项
export const saveKnowledge = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web-ct/knowledge/save`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//修改知识项
export const updateKnowledge = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web-ct/knowledge/update`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//删除知识项
export const deleteKnowledge = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/knowledge/delete?id=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//打印报告
export const ctPrintReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/printReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//获取体位
export const positionList = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/dict/${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//统计不同状态的记录数
export const ctStateCount = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web-ct/diagnosis/stateCount`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//点击继续审核
export const ctContinueVerify = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/continueVerify?reportId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//点击继续填写
export const ctContinueReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/continueReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//统计分析-远程诊断报告列表
export const diagStatistics = data => {
  const init = { method: 'GET' };
  let url = `/ai-web-ct/diagStatistics/listByPage?`;
  let params = [];
  if (data.startTime) params.push(`startTime=${data.startTime}`);
  if (data.endTime) params.push(`endTime=${data.endTime}`);
  if (data.institutionId) params.push(`institutionId=${data.institutionId}`);
  if (data.pageSize) params.push(`pageSize=${data.pageSize}`);
  if (data.pageNum) params.push(`pageNum=${data.pageNum}`);
  if (data.verifyUserId) params.push(`verifyUserId=${data.verifyUserId}`);
  if (data.reportUserId) params.push(`reportUserId=${data.reportUserId}`);
  return fetch(url + params.join('&'), init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//撤销报告
export const ctUndoReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/undoReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//撤销审核
export const ctUndoVerify = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/undoVerify?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//打印后报告纠错
export const ctUndoPrintReport = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/undoPrintReport?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//同姓名历史诊断信息
export const ctOneNameDiagList = id => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/oneNameDiagList?diagId=${id}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//远程诊断报告医生列表
export const ctReportDoctorList = (name = '') => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/reportDoctorList?name=${name}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//远程诊断报告审核医生列表
export const ctReviewDoctorList = (name = '') => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/diagnosis/reviewDoctorList?name=${name}`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//打印报告前校验是否可以打印
export const ctPermitPrintReport = id => {
  const init = { method: 'GET' };
  return fetch(
    `/ai-web-ct/diagnosis/permitPrintReport?diagId=${id}`,
    init
  ).then(res => res.json(), error => console.error(error));
};

//AI自动报告列表
export const aiReportList = data => {
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(data),
  };
  return fetch(`/ai-web-ct/aiReport/list`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

export const getToken = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/auth/getToken`, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//清空影像所见和诊断建议埋点
export const ctRmAiTxt = data => {
  const init = { method: 'GET' };
  let url = `/ai-web-ct/aiReport/rmAiTxt?aiReportId=${data.id}&types=${data.types}`;
  if (data.report) url += `&report=${data.report}`;
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//审核时退回重写
export const ctRefuseReView = id => {
  let url = `/ai-web-ct/diagnosis/refuseReView`;
  const post = { diagId: id };
  const init = {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    body: JSON.stringify(post),
  };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//随访记录
export const oneNameDicomList = id => {
  let url = `/ai-web-ct/diagnosis/oneNameDicomList?diagId=${id}`;
  const init = { method: 'GET' };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};

//疑难转诊
export const ctToVerify2 = id => {
  let url = `/ai-web-ct/diagnosis/toVerify2?diagId=${id}`;
  const init = { method: 'GET' };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};
//数据看板-远程诊断报告分析
export const serviceCountList = (beginTime, endTime) => {
  let url = `/ai-web-ct/report/service/count-list?beginTime=${beginTime}&endTime=${endTime}`;
  const init = { method: 'GET' };
  return fetch(url, init).then(
    res => res.json(),
    error => console.error(error)
  );
};
export const ctInstitutionRecord = (data = {}) => {
  const search = getParams(data);
  let url = `/ai-web-ct/fromDr/institutionRecord?` + search;

  return fetch(url, getInit).then(res => res.json(), err => console.error(err));
};
//下载dcm zip 包
export const ctDownloadDcm = diagId => {
  return fetch(
    `/ai-web-ct/diagnosis/dcm/download?diagId=${diagId}`,
    getInit
  ).then(res => res.text(), err => console.error(err));
};
export const ctLogin4Third = token => {
  const init = { ...putInit, body: token };
  return fetch(`/ai-web-ct/boxuser/login4Third`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
export const ctSysConfig = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/dict/sysConfig`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//民族字典
export const ctNational = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/dict/national`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//证件类型
export const ctIDType = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/dict/IDType`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//就诊卡类型字典
export const ctCardType = () => {
  const init = { method: 'GET' };
  return fetch(`/ai-web-ct/dict/cardType`, init).then(
    res => res.json(),
    err => console.error(err)
  );
};
//检查方法字典
export const ctCheckMethod = type => {
  let url = '/ai-web-ct/dict/methodMRI';
  if (type === 'CT') url = `/ai-web-ct/dict/methodCT`;
  return fetch(url, getInit).then(res => res.json(), err => console.error(err));
};

//查询"检查部位"的字典项
export const ctBodyPart = type => {
  let url = '/ai-web/dict/bodyPartMRI';
  if (type === 'CT') url = `/ai-web/dict/bodyPartCT`;
  return fetch(url, getInit).then(res => res.json(), err => console.error(err));
};

//获取dicom uids
export const ctDicomList = id => {
  return fetch(`/ai-web-ct/diagnosis/dicomCtList?diagId=${id}`, getInit).then(
    res => res.json(),
    err => console.error(err)
  );
};
